import React, { useState, useEffect, ReactElement } from 'react';
import { TImageResourceInfo } from '../../../types/types';
import resources from '../../../../public/resources/images/resources.json';
import Carousel from '../../Carousel';

const ImageTable: React.FC = (): ReactElement => {
  const [numberOfColumns, setNumberOfColumns] = useState(0);
  const [loadedImage, setLoadedImage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [index, setIndex] = useState(0);

  const resizeEventListener = () => {
    if (window.innerWidth > 767) {
      setNumberOfColumns(3);
    } else if (window.innerWidth < 640) {
      setNumberOfColumns(1);
    } else {
      setNumberOfColumns(2);
    }
  };

  useEffect(() => {
    resizeEventListener();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', resizeEventListener, false);
    return () => {
      window.removeEventListener('resize', resizeEventListener, false);
    };
  }, []);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [showModal]);

  const escHandler: (event: KeyboardEvent) => void = event => {
    if (event.key === 'Escape') {
      setShowModal(false);
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('keydown', escHandler);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('keydown', escHandler);
      }
    };
  }, []);

  const Cell = ({
    children,
    onClick,
  }: {
    children: React.ReactNode;
    onClick: () => void;
  }) => (
    <div
      onClick={onClick}
      aria-hidden="true"
      className="w-full box-border py-1 cursor-pointer"
    >
      {children}
    </div>
  );

  let slicedArray1: TImageResourceInfo[] = [];
  let slicedArray2: TImageResourceInfo[] = [];
  let slicedArray3: TImageResourceInfo[] = [];

  if (numberOfColumns === 3) {
    slicedArray1 = resources.slice(0, resources.length / 3 + 1);
    slicedArray2 = resources.slice(
      resources.length / 3 + 1,
      (resources.length / 3) * 2 + 1
    );
    slicedArray3 = resources.slice(
      (resources.length / 3) * 2 + 1,
      resources.length
    );
  } else if (numberOfColumns === 2) {
    slicedArray1 = resources.slice(0, resources.length / 2);
    slicedArray2 = resources.slice(resources.length / 2, resources.length);
  } else {
    slicedArray1 = resources;
  }

  const Column = ({ resources }: { resources: TImageResourceInfo[] }) => (
    <div className="flex flex-wrap flex-1 gap-1 px-1">
      {resources.map(resource => (
        <Cell
          key={resource.fileName}
          onClick={() => {
            setLoadedImage(resource.fileName);
            setShowModal(true);
          }}
        >
          <img
            src={`/static/resources/${resource.fileName}`}
            className="w-full"
            alt=""
          />
        </Cell>
      ))}
    </div>
  );

  return (
    <div className=" flex mb-8 flex-row max-w-md sm:max-w-lg md:max-w-2xl  lg:max-w-3xl">
      <div className="basis-1/1 sm:basis-1/2 md:basis-1/3">
        <Column resources={slicedArray1} />
      </div>
      {numberOfColumns > 1 && (
        <div className="basis-1/2 md:basis-1/3">
          <Column resources={slicedArray2} />
        </div>
      )}
      {numberOfColumns === 3 && (
        <div className="md:basis-1/3 ">
          <Column resources={slicedArray3} />
        </div>
      )}

      {showModal ? (
        <>
          <div className="flex flex-col justify-center text-light items-center overflow-hidden fixed inset-0 z-50  backdrop-brightness-0 ">
            <div className=" p-2 pl-6 flex flex-row w-full pr-6 ">
              <div className="basis-2/12" />
              <div className="flex justify-center  text-center basis-full">
                {index + 1}/{resources.length} images
              </div>
              <div className="flex justify-center  text-xs text-center  basis-2/12 hover:text-primary ">
                <button type="button" onClick={() => setShowModal(false)}>
                  <span>Close X</span>
                </button>
              </div>
            </div>
            <div className="w-full max-h-[44rem] flex justify-center">
              <Carousel
                onLoaded={loadedImage}
                onIndex={setIndex}
                resourceForCarousel={resources}
                type="image"
                currentIndex={index}
              />
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default ImageTable;
